export default __webpack_public_path__ + "static/media/highlight.4a0402b3.svg";